(()=>{
if(window.MOGA_RELATIONS_LOADED)return;window.MOGA_RELATIONS_LOADED=true;
const esc=v=>typeof escapeHtml==='function'?escapeHtml(v??''):String(v??'');
function open(type,ref){
  if(!type)return;
  try{
    if(type==='invoice'){
      /* Atidarome pačią SF peržiūrai. Anksčiau čia buvo uždedamas SEKIMO INFO paieškos filtras,
         todėl vartotojui galėjo atrodyti, kad visos kitos SF dingo. */
      if(typeof viewInvoiceByNo==='function' && ref){
        viewInvoiceByNo(encodeURIComponent(ref));
        return;
      }
      switchPage('tracking');
      const q=document.getElementById('trackingSearch');
      if(q){q.value='';renderTrackingInfo?.();q.focus()}
      return;
    }
    if(type==='purchase'){switchPage('purchases');setTimeout(()=>openPurchaseOrder?.(ref),60);return}
    if(type==='inventory-product'){
      switchPage('warehouse');
      setTimeout(()=>{
        switchInventoryPane?.('stock');
        const p=(window.MOGA_INVENTORY?.products?.()||[]).find(x=>x.inventoryId===ref);
        const q=document.getElementById('inventorySearch');
        const cat=document.getElementById('inventoryCategory'),st=document.getElementById('inventoryStatus'),low=document.getElementById('inventoryLowOnly');
        if(cat)cat.value='all';if(st)st.value='all';if(low)low.checked=false;
        if(q&&p){q.value=p.name;window.renderInventory?.();q.focus()}
      },80);
      return;
    }
    if(type==='product'){
      switchPage('invoice');toggleProductsDrawer?.(true);
      const p=(window.MOGA_INVENTORY?.products?.()||[]).find(x=>x.inventoryId===ref);
      if(p&&typeof editProductFull==='function'){const i=(typeof getProducts==='function'?getProducts():[]).findIndex(x=>x.inventoryId===ref||x.name===p.name);if(i>=0)setTimeout(()=>editProductFull(i),80)}
      return;
    }
    if(type==='supplier'){switchPage('purchases');setTimeout(()=>{switchPurchasePane?.('suppliers');openSupplier?.(ref)},60);return}
    if(type==='expense'){switchPage('expenses');setTimeout(()=>openExpense?.(ref),60);return}
    if(type==='return'){switchPage('warehouse');setTimeout(()=>{switchInventoryPane?.('returns');window.MOGA_RETURNS?.focus?.(ref)},80);return}
    if(type==='task'){switchPage('tasks');setTimeout(()=>openTask?.(ref),60);return}
    if(type==='client'){
      switchPage('invoice');toggleClientsDrawer?.(true);
      return;
    }
  }catch(e){console.warn('MOGA ryšio atidarymo klaida',e)}
}
window.MOGA_LINKS={open};
})();
